import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const NewsComponent = (props) => {
  const { t } = useTranslation();

  return (
   <article className="w-full max-w-[420px] bg-white overflow-hidden rounded-2xl shadow-lg hover:-translate-y-1 transition-transform flex flex-col justify-between h-auto">
      <div>
        {/* Обложка */}
        <div className="relative">
          <img
            className="h-[180px] sm:h-[220px] w-full object-cover"
            src={props.img}
            alt={props.title}
          />

          {/* Логотип компании поверх обложки */}
          <div className="absolute -bottom-8 left-5 bg-white p-1 rounded-2xl shadow-md z-10">
            <img
              src={
                props.companylogo
                  ? `/api/uploads/${props.companylogo}`
                  : "/api/default-company-logo.png"
              }
              alt={props.companyname}
              className="w-[60px] h-[60px] sm:w-[70px] sm:h-[70px] rounded-xl object-cover shrink-0"
            />
          </div>
        </div>

        {/* Контент */}
        <div className="pt-10 pb-4 px-4 sm:px-5 flex flex-col gap-1.5 min-w-0">
          {/* Имя компании */}
          <h3 className="text-sm sm:text-base font-semibold text-[#006674] truncate">
            {props.companyname || "Unknown Company"}
          </h3>
          
          {/* Заголовок: теперь он адаптивный по размеру и жестко ограничен 2 строками */}
          <h2 
            className="text-base sm:text-lg md:text-xl font-bold uppercase leading-snug text-gray-900 line-clamp-2"
            title={props.title} // При наведении покажет полный заголовок
          >
            {props.title}
          </h2>
          
          {/* Описание блогов: ограничим в 3 строки для идеального выравнивания */}
          <p className="text-gray-600 text-xs sm:text-sm line-clamp-3 mt-1">
            {props.description}
          </p>
        </div>
      </div>

      {/* Нижняя панель жестко прижимается к низу */}
      <div className="w-full p-3 px-4 sm:px-5 flex justify-between items-center bg-[#006674] text-white text-xs sm:text-sm mt-auto">
        <span className="flex items-center gap-1.5 opacity-90">
          <FontAwesomeIcon icon={faCalendarAlt} />
          <span>{props.date || "—"}</span>
        </span>
        <Link
          to={`/News/${props.id}`}
          className="font-semibold hover:underline"
        >
          {t("readmore")}
        </Link>
      </div>
    </article>
  );
};

export default NewsComponent;
